var _regeneratorRuntime = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _toConsumableArray = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _createClass = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _classCallCheck = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/assertThisInitialized");

var _inherits = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _wrapNativeSuper = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapNativeSuper");

var CODES = {
  JOSEAlgNotWhitelisted: 'ERR_JOSE_ALG_NOT_WHITELISTED',
  JOSECritNotUnderstood: 'ERR_JOSE_CRIT_NOT_UNDERSTOOD',
  JOSEInvalidEncoding: 'ERR_JOSE_INVALID_ENCODING',
  JOSEMultiError: 'ERR_JOSE_MULTIPLE_ERRORS',
  JOSENotSupported: 'ERR_JOSE_NOT_SUPPORTED',
  JWEDecryptionFailed: 'ERR_JWE_DECRYPTION_FAILED',
  JWEInvalid: 'ERR_JWE_INVALID',
  JWKImportFailed: 'ERR_JWK_IMPORT_FAILED',
  JWKInvalid: 'ERR_JWK_INVALID',
  JWKKeySupport: 'ERR_JWK_KEY_SUPPORT',
  JWKSNoMatchingKey: 'ERR_JWKS_NO_MATCHING_KEY',
  JWSInvalid: 'ERR_JWS_INVALID',
  JWSVerificationFailed: 'ERR_JWS_VERIFICATION_FAILED',
  JWTClaimInvalid: 'ERR_JWT_CLAIM_INVALID',
  JWTExpired: 'ERR_JWT_EXPIRED',
  JWTMalformed: 'ERR_JWT_MALFORMED'
};
var DEFAULT_MESSAGES = {
  JWEDecryptionFailed: 'decryption operation failed',
  JWEInvalid: 'JWE invalid',
  JWKSNoMatchingKey: 'no matching key found in the KeyStore',
  JWSInvalid: 'JWS invalid',
  JWSVerificationFailed: 'signature verification failed'
};

var JOSEError =
/*#__PURE__*/
function (_Error) {
  "use strict";

  _inherits(JOSEError, _Error);

  function JOSEError(message) {
    var _this;

    _classCallCheck(this, JOSEError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(JOSEError).call(this, message));

    if (message === undefined) {
      _this.message = DEFAULT_MESSAGES[_this.constructor.name];
    }

    _this.name = _this.constructor.name;
    _this.code = CODES[_this.constructor.name];
    Error.captureStackTrace(_assertThisInitialized(_this), _this.constructor);
    return _this;
  }

  return JOSEError;
}(_wrapNativeSuper(Error));

var isMulti = function isMulti(e) {
  return e instanceof JOSEMultiError;
};

var JOSEMultiError =
/*#__PURE__*/
function (_JOSEError) {
  "use strict";

  _inherits(JOSEMultiError, _JOSEError);

  function JOSEMultiError(errors) {
    var _this2;

    _classCallCheck(this, JOSEMultiError);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(JOSEMultiError).call(this));
    var i;

    while ((i = errors.findIndex(isMulti)) && i !== -1) {
      errors.splice.apply(errors, [i, 1].concat(_toConsumableArray(errors[i])));
    }

    Object.defineProperty(_assertThisInitialized(_this2), 'errors', {
      value: errors
    });
    return _this2;
  }

  _createClass(JOSEMultiError, [{
    key: Symbol.iterator,
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function value() {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, error;

      return _regeneratorRuntime.wrap(function value$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 3;
              _iterator = this.errors[Symbol.iterator]();

            case 5:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context.next = 12;
                break;
              }

              error = _step.value;
              _context.next = 9;
              return error;

            case 9:
              _iteratorNormalCompletion = true;
              _context.next = 5;
              break;

            case 12:
              _context.next = 18;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](3);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 18:
              _context.prev = 18;
              _context.prev = 19;

              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }

            case 21:
              _context.prev = 21;

              if (!_didIteratorError) {
                _context.next = 24;
                break;
              }

              throw _iteratorError;

            case 24:
              return _context.finish(21);

            case 25:
              return _context.finish(18);

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, value, this, [[3, 14, 18, 26], [19,, 21, 25]]);
    })
  }]);

  return JOSEMultiError;
}(JOSEError);

module.exports.JOSEError = JOSEError;

module.exports.JOSEAlgNotWhitelisted =
/*#__PURE__*/
function (_JOSEError2) {
  "use strict";

  _inherits(JOSEAlgNotWhitelisted, _JOSEError2);

  function JOSEAlgNotWhitelisted() {
    _classCallCheck(this, JOSEAlgNotWhitelisted);

    return _possibleConstructorReturn(this, _getPrototypeOf(JOSEAlgNotWhitelisted).apply(this, arguments));
  }

  return JOSEAlgNotWhitelisted;
}(JOSEError);

module.exports.JOSECritNotUnderstood =
/*#__PURE__*/
function (_JOSEError3) {
  "use strict";

  _inherits(JOSECritNotUnderstood, _JOSEError3);

  function JOSECritNotUnderstood() {
    _classCallCheck(this, JOSECritNotUnderstood);

    return _possibleConstructorReturn(this, _getPrototypeOf(JOSECritNotUnderstood).apply(this, arguments));
  }

  return JOSECritNotUnderstood;
}(JOSEError);

module.exports.JOSEInvalidEncoding =
/*#__PURE__*/
function (_JOSEError4) {
  "use strict";

  _inherits(JOSEInvalidEncoding, _JOSEError4);

  function JOSEInvalidEncoding() {
    _classCallCheck(this, JOSEInvalidEncoding);

    return _possibleConstructorReturn(this, _getPrototypeOf(JOSEInvalidEncoding).apply(this, arguments));
  }

  return JOSEInvalidEncoding;
}(JOSEError);

module.exports.JOSEMultiError = JOSEMultiError;

module.exports.JOSENotSupported =
/*#__PURE__*/
function (_JOSEError5) {
  "use strict";

  _inherits(JOSENotSupported, _JOSEError5);

  function JOSENotSupported() {
    _classCallCheck(this, JOSENotSupported);

    return _possibleConstructorReturn(this, _getPrototypeOf(JOSENotSupported).apply(this, arguments));
  }

  return JOSENotSupported;
}(JOSEError);

module.exports.JWEDecryptionFailed =
/*#__PURE__*/
function (_JOSEError6) {
  "use strict";

  _inherits(JWEDecryptionFailed, _JOSEError6);

  function JWEDecryptionFailed() {
    _classCallCheck(this, JWEDecryptionFailed);

    return _possibleConstructorReturn(this, _getPrototypeOf(JWEDecryptionFailed).apply(this, arguments));
  }

  return JWEDecryptionFailed;
}(JOSEError);

module.exports.JWEInvalid =
/*#__PURE__*/
function (_JOSEError7) {
  "use strict";

  _inherits(JWEInvalid, _JOSEError7);

  function JWEInvalid() {
    _classCallCheck(this, JWEInvalid);

    return _possibleConstructorReturn(this, _getPrototypeOf(JWEInvalid).apply(this, arguments));
  }

  return JWEInvalid;
}(JOSEError);

module.exports.JWKImportFailed =
/*#__PURE__*/
function (_JOSEError8) {
  "use strict";

  _inherits(JWKImportFailed, _JOSEError8);

  function JWKImportFailed() {
    _classCallCheck(this, JWKImportFailed);

    return _possibleConstructorReturn(this, _getPrototypeOf(JWKImportFailed).apply(this, arguments));
  }

  return JWKImportFailed;
}(JOSEError);

module.exports.JWKInvalid =
/*#__PURE__*/
function (_JOSEError9) {
  "use strict";

  _inherits(JWKInvalid, _JOSEError9);

  function JWKInvalid() {
    _classCallCheck(this, JWKInvalid);

    return _possibleConstructorReturn(this, _getPrototypeOf(JWKInvalid).apply(this, arguments));
  }

  return JWKInvalid;
}(JOSEError);

module.exports.JWKKeySupport =
/*#__PURE__*/
function (_JOSEError10) {
  "use strict";

  _inherits(JWKKeySupport, _JOSEError10);

  function JWKKeySupport() {
    _classCallCheck(this, JWKKeySupport);

    return _possibleConstructorReturn(this, _getPrototypeOf(JWKKeySupport).apply(this, arguments));
  }

  return JWKKeySupport;
}(JOSEError);

module.exports.JWKSNoMatchingKey =
/*#__PURE__*/
function (_JOSEError11) {
  "use strict";

  _inherits(JWKSNoMatchingKey, _JOSEError11);

  function JWKSNoMatchingKey() {
    _classCallCheck(this, JWKSNoMatchingKey);

    return _possibleConstructorReturn(this, _getPrototypeOf(JWKSNoMatchingKey).apply(this, arguments));
  }

  return JWKSNoMatchingKey;
}(JOSEError);

module.exports.JWSInvalid =
/*#__PURE__*/
function (_JOSEError12) {
  "use strict";

  _inherits(JWSInvalid, _JOSEError12);

  function JWSInvalid() {
    _classCallCheck(this, JWSInvalid);

    return _possibleConstructorReturn(this, _getPrototypeOf(JWSInvalid).apply(this, arguments));
  }

  return JWSInvalid;
}(JOSEError);

module.exports.JWSVerificationFailed =
/*#__PURE__*/
function (_JOSEError13) {
  "use strict";

  _inherits(JWSVerificationFailed, _JOSEError13);

  function JWSVerificationFailed() {
    _classCallCheck(this, JWSVerificationFailed);

    return _possibleConstructorReturn(this, _getPrototypeOf(JWSVerificationFailed).apply(this, arguments));
  }

  return JWSVerificationFailed;
}(JOSEError);

var JWTClaimInvalid =
/*#__PURE__*/
function (_JOSEError14) {
  "use strict";

  _inherits(JWTClaimInvalid, _JOSEError14);

  function JWTClaimInvalid(message) {
    var _this3;

    var claim = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'unspecified';
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'unspecified';

    _classCallCheck(this, JWTClaimInvalid);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(JWTClaimInvalid).call(this, message));
    _this3.claim = claim;
    _this3.reason = reason;
    return _this3;
  }

  return JWTClaimInvalid;
}(JOSEError);

module.exports.JWTClaimInvalid = JWTClaimInvalid;

module.exports.JWTExpired =
/*#__PURE__*/
function (_JWTClaimInvalid) {
  "use strict";

  _inherits(JWTExpired, _JWTClaimInvalid);

  function JWTExpired() {
    _classCallCheck(this, JWTExpired);

    return _possibleConstructorReturn(this, _getPrototypeOf(JWTExpired).apply(this, arguments));
  }

  return JWTExpired;
}(JWTClaimInvalid);

module.exports.JWTMalformed =
/*#__PURE__*/
function (_JOSEError15) {
  "use strict";

  _inherits(JWTMalformed, _JOSEError15);

  function JWTMalformed() {
    _classCallCheck(this, JWTMalformed);

    return _possibleConstructorReturn(this, _getPrototypeOf(JWTMalformed).apply(this, arguments));
  }

  return JWTMalformed;
}(JOSEError);